module.exports = __webpack_public_path__ + "static/media/bang.791514a6.png";